function toCents(s){ return Math.round(parseFloat(s)*100); }   // Storefront 主单位小数 → cents
function computeNet(cart, opts){
  var level=(opts&&opts.level)||'line';
  var edges=cart&&cart.lines&&cart.lines.edges; if(!edges||!edges.length) return null;
  var net=0,sub=0,cur='USD';
  for(var i=0;i<edges.length;i++){ var co=edges[i]&&edges[i].node&&edges[i].node.cost;
    if(!co||!co.totalAmount||co.totalAmount.amount==null) return null;     // 任一行缺 cost → null（line+order 都先校验）
    net+=toCents(co.totalAmount.amount); sub+=co.subtotalAmount?toCents(co.subtotalAmount.amount):toCents(co.totalAmount.amount);
    cur=co.totalAmount.currencyCode||cur; }
  if (level==='order'){ var c=cart.cost; if(!c||!c.totalAmount||c.totalAmount.amount==null) return null;
    // clamp like the line path: tax-inclusive markets can make totalAmount > subtotalAmount,
    // and saved must never go negative (a negative would suppress a real Save badge)
    return { netCents:toCents(c.totalAmount.amount),
             savedCents:c.subtotalAmount? Math.max(0, toCents(c.subtotalAmount.amount)-toCents(c.totalAmount.amount)):0,
             currency:c.totalAmount.currencyCode||cur }; }
  return { netCents:net, savedCents:Math.max(0,sub-net), currency:cur };
}

function hasThrottle(json){ function scan(a){return Array.isArray(a)&&a.some(function(e){return e&&/throttl/i.test(e.message||'');});}
  if(!json) return false; if(scan(json.errors)) return true; var cc=json.data&&json.data.cartCreate; return !!(cc&&scan(cc.userErrors)); }
function classify(status, json, expectedCount){
  if(status===429||status===430) return {kind:'throttled'};
  if(status!==200||!json) return {kind:'neutral'};
  if(hasThrottle(json)) return {kind:'throttled'};
  if(json.errors&&json.errors.length) return {kind:'neutral'};            // 非 throttle top-level error → 中性
  var cc=json.data&&json.data.cartCreate;
  if(!cc||(cc.userErrors&&cc.userErrors.length)||!cc.cart) return {kind:'neutral'};
  var edges=cc.cart.lines&&cc.cart.lines.edges;
  if(!edges||!edges.length) return {kind:'neutral'};
  if(expectedCount!=null && edges.length!==expectedCount) return {kind:'neutral'};   // 行数不符 → 中性
  return {kind:'ok', cart:cc.cart};
}

function campaignFormatMoney(cents, format){
  if(typeof cents==='string') cents=cents.replace('.','');
  var fmt=format||(typeof window!=='undefined'&&window.themeVariables&&window.themeVariables.settings.moneyFormat)||'${{amount}}';
  var ph=/\{\{\s*(\w+)\s*\}\}/;
  function fwd(number,precision,thousands,decimal){
    precision=precision==null?2:precision; thousands=thousands==null?',':thousands; decimal=decimal==null?'.':decimal;
    if(isNaN(number)||number==null) return '0';
    number=(number/100).toFixed(precision);
    var parts=number.split('.'), d=parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,'$1'+thousands), c=parts[1]?decimal+parts[1]:'';
    return d+c;
  }
  var m=fmt.match(ph); if(!m) return fmt; var value='';
  switch(m[1]){
    case 'amount': value=fwd(cents,2); break;
    case 'amount_no_decimals': value=fwd(cents,0); break;
    case 'amount_with_space_separator': value=fwd(cents,2,' ','.'); break;
    case 'amount_with_comma_separator': value=fwd(cents,2,'.',','); break;
    case 'amount_with_apostrophe_separator': value=fwd(cents,2,"'",'.'); break;
    case 'amount_no_decimals_with_comma_separator': value=fwd(cents,0,'.',','); break;
    case 'amount_no_decimals_with_space_separator': value=fwd(cents,0,' '); break;
    case 'amount_no_decimals_with_apostrophe_separator': value=fwd(cents,0,"'"); break;
    default: value=fwd(cents,2);
  }
  return fmt.replace(ph,value);
}

var QUERY_LINE='mutation P($lines:[CartLineInput!]!,$country:CountryCode)@inContext(country:$country){cartCreate(input:{lines:$lines}){cart{id lines(first:20){edges{node{merchandise{... on ProductVariant{id}}cost{subtotalAmount{amount currencyCode}totalAmount{amount currencyCode}}discountAllocations{discountedAmount{amount currencyCode}targetType ... on CartAutomaticDiscountAllocation{title}}}}}}userErrors{field message}}}';
var QUERY_ORDER='mutation P($lines:[CartLineInput!]!,$country:CountryCode)@inContext(country:$country){cartCreate(input:{lines:$lines}){cart{id cost{subtotalAmount{amount currencyCode}totalAmount{amount currencyCode}} lines(first:20){edges{node{merchandise{... on ProductVariant{id}}cost{subtotalAmount{amount currencyCode}totalAmount{amount currencyCode}}discountAllocations{discountedAmount{amount currencyCode}targetType ... on CartAutomaticDiscountAllocation{title}}}}}}userErrors{field message}}}';
function makePricer(opts){ opts = opts || {};
  var fetchImpl=opts.fetchImpl||(typeof window!=='undefined' ? window.fetch.bind(window) : null);
  var sleep=opts.sleep||function(ms){return new Promise(function(r){setTimeout(r,ms);});};
  var token=opts.token||'', country=opts.country||null, api=opts.api||'2026-04';
  var maxRetries=(opts.maxRetries==null?3:opts.maxRetries);
  var API=(opts.origin||(typeof location!=='undefined'?location.origin:''))+'/api/'+api+'/graphql.json';
  function toLines(items){ return items.map(function(it){ return {merchandiseId:'gid://shopify/ProductVariant/'+it.id, quantity:it.quantity||1}; }); }
  function sig(items,c,level){ return JSON.stringify(toLines(items))+'|'+(c||'')+'|'+(level||'line'); }
  async function probeOnce(items,country,level,useToken){
    var ctrl=new AbortController(), timer=setTimeout(function(){ctrl.abort();},5000);
    try{
      var headers={'Content-Type':'application/json'};
      if(useToken && token) headers['X-Shopify-Storefront-Access-Token']=token;
      var res=await fetchImpl(API,{method:'POST',headers:headers,signal:ctrl.signal,
        body:JSON.stringify({query: level==='order'?QUERY_ORDER:QUERY_LINE, variables:{lines:toLines(items),country:country||null}})});
      var json=null; try{ json=await res.json(); }catch(e){ json=null; }
      return {status:res.status, json:json};
    }catch(e){ return {status:0, json:null}; }
    finally{ clearTimeout(timer); }
  }
  async function withRetry(items, c, level){
    var attempt=0, useToken=false, authTried=false;
    while(true){
      var r=await probeOnce(items,c,level,useToken);
      var cl=classify(r.status, r.json, items.length);
      if(cl.kind==='ok'){ var cn=computeNet(cl.cart,{level:level}); return cn?{status:'ok',netCents:cn.netCents,savedCents:cn.savedCents,currency:cn.currency}:{status:'neutral'}; }
      if(cl.kind==='throttled'){ if(attempt>=maxRetries) return {status:'neutral'}; attempt++; useToken=true; await sleep(Math.min(600*Math.pow(2,attempt-1)+Math.random()*150, 5000)); continue; }
      if((r.status===401||r.status===403) && token && !useToken && !authTried){ authTried=true; useToken=true; continue; }
      return {status:'neutral'};
    }
  }
  var TTL=60000, cache=new Map(), inflight=new Map();
  // paint window: peek() may render a cached price for up to 10min so tab/capacity switches
  // never flash "at checkout" after the 60s network-confirm TTL lapses; the recalc that
  // follows every switch still re-probes past TTL, so the on-screen number is re-confirmed
  // against checkout within one probe round-trip (values virtually never differ).
  var PAINT_TTL=(opts.paintTtl==null?600000:opts.paintTtl);
  var now=opts.now||function(){ return Date.now(); };
  var poolSize=opts.poolSize||4, active=0, q=[];
  function runPool(fn){ return new Promise(function(resolve){ q.push({fn:fn,resolve:resolve}); pump(); }); }
  function pump(){ while(active<poolSize && q.length){ var it=q.shift(); active++;
    Promise.resolve(it.fn()).then(function(v){ active--; it.resolve(v); pump(); },
                                 function(){ active--; it.resolve({status:'neutral'}); pump(); }); } }
  function priceTab(items, opts2){
    var level=(opts2&&opts2.level)||'line', k=sig(items,country,level);
    var hit=cache.get(k); if(hit && (now()-hit.t)<TTL) return Promise.resolve(hit.result);
    if(inflight.has(k)) return inflight.get(k);
    var pr=runPool(function(){ return withRetry(items,country,level); }).then(function(r){
      inflight.delete(k);
      if(r && r.status==='ok') cache.set(k,{t:now(),result:r});
      return r;
    });
    inflight.set(k,pr); return pr;
  }
  // Synchronous cache peek (no network): returns a cached 'ok' result within the PAINT
  // window (10min), else null. Lets the UI render the last confirmed price instantly on
  // tab/capacity switch instead of flashing the "at checkout" placeholder. Same key as
  // priceTab(). Past the 60s TTL the value is painted as-is and the caller's recalc()
  // re-probes to confirm (stale-paint-then-confirm; prices are stable within minutes).
  function peek(items, opts2){
    var level=(opts2&&opts2.level)||'line', k=sig(items,country,level);
    var hit=cache.get(k);
    return (hit && (now()-hit.t)<PAINT_TTL) ? hit.result : null;
  }
  return { priceTab: priceTab, peek: peek, country: country };
}

if (typeof window !== 'undefined') {
  var cfgEl = document.getElementById('campaign-fp-config'); var cfg = {};
  try { cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {}; } catch (e) {}
  if (!window.CampaignPricing) window.CampaignPricing = makePricer({
    fetchImpl: window.fetch.bind(window), sleep:(ms)=>new Promise(r=>setTimeout(r,ms)),
    origin: location.origin, api: cfg.api || '2026-04', token: cfg.k || '', country: cfg.country || null });
  window.campaignFormatMoney = campaignFormatMoney;   // expose for campaign.js canvas price (locale-correct money format)
}
if (typeof module !== 'undefined' && module.exports) module.exports = { computeNet, classify, campaignFormatMoney, makePricer };
